module.exports = __webpack_public_path__ + "static/logo-light-9dc91e170c5da8964c0fcc1db40743da.png";